// Actions
import { UserActions, UserActionsTypes } from './user.actions';

// Models
import { UserState } from './user.state';
import { SearchSettings } from '../../shared/models/b2b/searchSettings';
import { UserHelper } from '../../shared/models/b2b/user';
import { select } from '@ngrx/store';

const defaultState: UserState = {
    loading: false,
    data: UserHelper.create(),
    payMethods: {},
    settings: new SearchSettings(),
    orderBy: undefined,
    searchTerms: undefined,
    addresses: undefined,
    manualAddressChange: null,
    bill: undefined,
    saldoTotal: 0,
    movimientosSaldo: [],
    saldosDisponibles: []
};

export type Action = UserActions;

export function UserReducer(state = defaultState, action: any) {
    // console.log(state, action);
    switch (action.type) {
        case UserActionsTypes.DO_GET_INFO:
            return {
                ...state,
                loading: true,
                data: {}
            };

        case UserActionsTypes.DO_GET_INFO_OK:
            return {
                ...state,
                loading: false,
                data: action.payload
            };

        case UserActionsTypes.DO_GET_INFO_KO:
            return {
                ...state,
                loading: false,
                data: {}
            };

        case UserActionsTypes.DO_GET_SETTINGS:
            return {
                ...state,
                loading: true,
                settings: undefined
            };

        case UserActionsTypes.DO_GET_SETTINGS_OK:
            return {
                ...state,
                loading: false,
                settings: { ...action.payload }
            };

        case UserActionsTypes.DO_GET_SETTINGS_KO:
            return {
                ...state,
                loading: false,
                settings: undefined
            };

        case UserActionsTypes.DO_GET_ADDRESSES:
            return {
                ...state,
                loading: true,
                addresses: undefined
            };

        case UserActionsTypes.DO_GET_ADDRESSES_OK:
            let defaultAdd = null;
            action.payload.forEach((address, index) => {
                if (address.defecto) {
                    defaultAdd = address;
                }
            });
            if (!defaultAdd) {
                defaultAdd = action.payload.length > 0 ? action.payload[action.payload.length - 1] : null;
            }

            if (!defaultAdd) {
                defaultAdd =
                    state.data.addresses.length > 0 ? state.data.addresses[state.data.addresses.length - 1] : null;
            }

            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    addresses: action.payload,
                    selectedAddress: defaultAdd ? defaultAdd.id : null,
                    selectedAddressCode: defaultAdd ? defaultAdd.codigo : null,
                    almacenNombre: defaultAdd ? defaultAdd.almacenNombre : '',
                    almacenCodigo: defaultAdd ? defaultAdd.almacenCodigo : '',
                    confirmarPedido:
                        defaultAdd && (defaultAdd.almacenCodigo || typeof defaultAdd.almacenCodigo === 'number')
                            ? state.data.confirmarPedido
                            : false
                },
                addresses: action.payload
            };

        case UserActionsTypes.DO_GET_ADDRESSES_KO:
            return {
                ...state,
                loading: false,
                data: { ...state.data, addresses: undefined },
                addresses: undefined
            };

        case UserActionsTypes.DO_GET_ORDERBY:
            return {
                ...state,
                loading: true,
                orderBy: undefined
            };

        case UserActionsTypes.DO_GET_ORDERBY_OK:
            return {
                ...state,
                loading: false,
                orderBy: action.payload
            };

        case UserActionsTypes.DO_GET_ORDERBY_KO:
            return {
                ...state,
                loading: false,
                orderBy: undefined
            };

        case UserActionsTypes.DO_GET_FREQUENT_SEARCH_TERMS:
            return {
                ...state,
                loading: true,
                searchTerms: undefined
            };

        case UserActionsTypes.DO_GET_FREQUENT_SEARCH_TERMS_OK:
            return {
                ...state,
                loading: false,
                searchTerms: action.payload
            };

        case UserActionsTypes.DO_GET_FREQUENT_SEARCH_TERMS_KO:
            return {
                ...state,
                loading: false,
                searchTerms: undefined
            };

        case UserActionsTypes.DO_GET_PAYMETHODS:
            return {
                ...state,
                loading: true,
                payMethods: []
            };

        case UserActionsTypes.DO_GET_PAYMETHODS_OK:
            return {
                ...state,
                loading: false,
                payMethods: action.payload
            };

        case UserActionsTypes.DO_GET_PAYMETHODS_KO:
            return {
                ...state,
                loading: false,
                payMethods: []
            };

        case UserActionsTypes.DO_CLEAR_SETTINGS:
            return {
                ...state,
                settings: new SearchSettings()
            };

        case UserActionsTypes.DO_SET_CLIENT:
            return {
                ...state,
                data: action.payload
            };

        case UserActionsTypes.DO_SET_ADDRESSES:
            // Default Address
            let defaultAddress = null;
            let manualAddressChange = null;
            action.payload.addresses.forEach((address, index) => {
                if (address.defecto) {
                    defaultAddress = address;
                    if (action.payload.manualChange) {
                        manualAddressChange = address.id;
                    }
                }
            });
            if (!defaultAddress) {
                defaultAddress =
                    action.payload.addresses.length > 0
                        ? action.payload.addresses[action.payload.addresses.length - 1]
                        : null;
            }

            return {
                ...state,
                addresses: [...action.payload.addresses],
                manualAddressChange,
                data: {
                    ...state.data,
                    selectedAddress:
                        defaultAddress && !isNaN(Number(defaultAddress.id)) ? Number(defaultAddress.id) : null,
                    selectedAddressCode:
                        defaultAddress && !isNaN(Number(defaultAddress.codigo)) ? Number(defaultAddress.codigo) : null,
                    almacenNombre: defaultAddress ? defaultAddress.almacenNombre : '',
                    almacenCodigo:
                        defaultAddress && !isNaN(Number(defaultAddress.almacenCodigo))
                            ? defaultAddress.almacenCodigo
                            : '',
                    addresses: [...action.payload.addresses],
                    confirmarPedido:
                        defaultAddress &&
                        (defaultAddress.almacenCodigo || typeof defaultAddress.almacenCodigo === 'number')
                            ? state.data.confirmarPedido
                            : false
                }
            };

        case UserActionsTypes.DO_GET_BILL:
            return {
                ...state,
                loading: true,
                bill: undefined
            };

        case UserActionsTypes.DO_GET_BILL_OK:
            return {
                ...state,
                loading: false,
                bill: action.payload
            };

        case UserActionsTypes.DO_GET_BILL_KO:
            return {
                ...state,
                loading: false,
                bill: undefined
            };
        case UserActionsTypes.DO_SAVE_GIFT_ADDRESS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    defaultGiftAddress: action.payload
                }
            };
        case UserActionsTypes.DO_SET_SALDO_TOTAL:
            return {
                ...state,
                saldoTotal: action.payload
            };

        case UserActionsTypes.DO_SET_SALDO_MOVIMIENTOS:
            return {
                ...state,
                movimientosSaldo: [...action.payload]
            };

        case UserActionsTypes.DO_SET_SALDOS_DISPONIBLES:
            return {
                ...state,
                saldosDisponibles: [...action.payload]
            };

        case UserActionsTypes.DO_SET_USER_SETTINGS:
            return {
                ...state,
                settings: { ...action.payload.settings }
            };

        default:
            return state;
    }
}
